import Mutations from '../../odata/mutations';

export default { ...new Mutations('csvOrderLine'), ...new Mutations('csvOrderLines') };
